import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { ConfigService } from '@jms/ui/ui.standalone.services/config.service';
import { UtilService } from '@jms/utils/util.services';
import { DomainType, DomainUtility } from '@jms/model';

if (ConfigService.environment.production) {
  enableProdMode();
}

const domain = UtilService.getLocation().hostName;

switch (DomainUtility.getDomainType(domain)) {
  case DomainType.Id: {
    import('./app/id/id.app.config').then(config => {
      import('./app/id/id.app.component').then(component => {
        bootstrapApplication(component.IdAppComponent, config.idAppConfig).catch(err => console.error(err));
      });
    });
    break;
  }

  case DomainType.Register: {
    import('./app/registration/registration.app.config').then(config => {
      import('./app/registration/components/app').then(component => {
        bootstrapApplication(component.RegistrationAppComponent, config.registrationAppConfig).catch(err => console.error(err));
      });
    });
    break;
  }
}


